module.exports = __webpack_public_path__ + "static/media/no-data.dbfb5f67.png";